export const initialState = {
  ebillings: [],
  nextTokens: { 1: null },
  kapItems: [],
  newEbilling: {},
  newEbillingMass: [],
  ebilling: {},
  initialData: {},
  usage: 0,
  error: null,
  loading: false,
  ebillingSchedules: [],
  scheduleLoading: false,
  scheduleError: null,
  newEbillingSchedule: {},
  newEbillingScheduleLoading: false,
  newEbillingScheduleError: null,
  deleteScheduleID: "",
  deleteScheduleIDLoading: false,
  deleteScheduleIDError: null,
  ebillingSchedule: {},
  updateSchedule: {},
  submitLoading: false,
  submitError: null,
  billingCodes: [],
  billingCodesLoading: false,
  billingCodesError: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case "REQUEST_LIST_EBILLING":
      return {
        ...state,
        request: action.payload.request,
        ebillings: [],
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        nextToken: null,
        error: null,
        loading: true,
      };
    case "LIST_EBILLING_SUCCESS":
      return {
        ...state,
        request: null,
        ebillings: action.payload.items,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
        loading: false,
      };
    case "LIST_EBILLING_ERROR":
      return {
        ...state,
        request: null,
        loading: false,
        error: action.error,
      };
    case "REQUEST_LIST_KAP":
      return {
        ...state,
        kapItems: [],
        error: null,
        loading: true,
      };
    case "LIST_KAP_SUCCESS":
      return {
        ...state,
        kapItems: action.payload.items,
        loading: false,
      };
    case "LIST_KAP_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "REQUEST_CREATE_EBILLING":
      return {
        ...state,
        newEbilling: {},
        error: null,
        loading: true,
      };
    case "CREATE_EBILLING_SUCCESS":
      return {
        ...state,
        newEbilling: action.payload.ebilling,
        loading: false,
      };
    case "CREATE_EBILLING_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "REQUEST_CREATE_EBILLING_MASS":
      return {
        ...state,
        newEbillingMass: [],
        error: null,
        loading: true,
      };
    case "CREATE_EBILLING_MASS_SUCCESS":
      return {
        ...state,
        newEbillingMass: action.payload.ebillings,
        loading: false,
      };
    case "CREATE_EBILLING_MASS_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "RESET_NEW_EBILLING":
      return {
        ...state,
        newEbilling: {},
        newEbillingMass: [],
        error: null,
        loading: false,
      };
    case "REQUEST_GET_EBILLING":
      return {
        ...state,
        ebilling: {},
        error: null,
        loading: true,
      };
    case "GET_EBILLING_SUCCESS":
      return {
        ...state,
        ebilling: action.payload.ebilling,
        loading: false,
      };
    case "GET_EBILLING_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "REQUEST_LIST_EBILLING_USAGE":
      return {
        ...state,
        usage: 0,
        error: null,
        loading: true,
      };
    case "LIST_EBILLING_USAGE_SUCCESS":
      return {
        ...state,
        usage: action.payload.usage,
        loading: false,
      };
    case "LIST_EBILLING_USAGE_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    case "SET_EBILLING_INITIAL_DATA":
      return {
        ...state,
        initialData: action.payload.initialData,
      };
    case "CLEAR_EBILLING_INITIAL_DATA":
      return {
        ...state,
        initialData: {},
      };
    case "REQUEST_LIST_SCHEDULED_EBILLING":
      return {
        ...state,
        ebillingSchedules: [],
        nextTokens:
          action.payload.page === 1
            ? initialState.nextTokens
            : state.nextTokens,
        nextToken: null,
        scheduleError: null,
        scheduleLoading: true,
      };
    case "LIST_SCHEDULED_EBILLING_SUCCESS":
      return {
        ...state,
        ebillingSchedules: action.payload.items,
        nextTokens: {
          ...state.nextTokens,
          [action.payload.nextPage]: action.payload.nextToken,
        },
        scheduleLoading: false,
      };
    case "LIST_SCHEDULED_EBILLING_ERROR":
      return {
        ...state,
        request: null,
        scheduleLoading: false,
        scheduleError: action.error,
      };
    case "REQUEST_CREATE_SCHEDULED_EBILLING":
      return {
        ...state,
        newEbillingSchedule: {},
        newEbillingScheduleError: null,
        newEbillingScheduleLoading: true,
      };
    case "SUCCESS_CREATE_SCHEDULED_EBILLING":
      return {
        ...state,
        newEbillingSchedule: action.payload.ebillingSchedule,
        newEbillingScheduleLoading: false,
      };
    case "ERROR_CREATE_SCHEDULED_EBILLING":
      return {
        ...state,
        newEbillingScheduleLoading: false,
        newEbillingScheduleError: action.error,
      };
    case "REQUEST_DELETE_SCHEDULED_EBILLING":
      return {
        ...state,
        request: action.payload.request,
        deleteScheduleIDLoading: true,
        deleteScheduleIDError: null,
        deleteScheduleID: "",
      };
    case "DELETE_SCHEDULED_EBILLING_SUCCESS":
      return {
        ...state,
        request: null,
        deleteScheduleIDLoading: false,
        deleteScheduleID: action.payload.ebillingScheduleID,
        ebillingSchedules: state.ebillingSchedules.filter(
          (item) => item.id !== action.payload.ebillingScheduleID
        ),
      };
    case "DELETE_SCHEDULED_EBILLING_ERROR":
      return {
        ...state,
        request: null,
        deleteScheduleIDLoading: false,
        deleteScheduleIDError: action.error,
      };
    case "RESET_DELETE_SCHEDULED_EBILLING":
      return {
        ...state,
        deleteScheduleID: "",
        deleteScheduleIDError: null,
      };
    case "REQUEST_GET_SCHEDULED_EBILLING":
      return {
        ...state,
        ebillingSchedule: {},
        scheduleError: null,
        scheduleLoading: true,
      };
    case "GET_SCHEDULED_EBILLING_SUCCESS":
      return {
        ...state,
        ebillingSchedule: action.payload.ebillingSchedule,
        scheduleLoading: false,
      };
    case "GET_SCHEDULED_EBILLING_ERROR":
      return {
        ...state,
        scheduleLoading: false,
        scheduleError: action.error,
      };
    case "REQUEST_UPDATE_SCHEDULED_EBILLING":
      return {
        ...state,
        submitLoading: true,
        submitError: null,
        updateSchedule: {},
      };
    case "SUCCESS_UPDATE_SCHEDULED_EBILLING":
      const { ebillingSchedule } = action.payload;
      const updatedEbillingSchedules = state.ebillingSchedules.map(
        (scheduleItem) =>
          scheduleItem.id === ebillingSchedule?.id
            ? ebillingSchedule
            : scheduleItem
      );
      return {
        ...state,
        submitLoading: false,
        updateSchedule: ebillingSchedule,
        ebillingSchedules: updatedEbillingSchedules,
      };
    case "ERROR_UPDATE_SCHEDULED_EBILLING":
      return {
        ...state,
        submitLoading: false,
        submitError: action.error,
      };
    case "RESET_SCHEDULED_EBILLING":
      return {
        ...state,
        newEbillingSchedule: {},
        newEbillingScheduleError: null,
        updateSchedule: {},
        submitError: null,
        ebillingSchedule: {},
      };
    case "REQUEST_BILLING_INPUT_CODE":
      return {
        ...state,
        billingCodes: [],
        billingCodesLoading: true,
        billingCodesError: null,
      };
    case "SUCCESS_BILLING_INPUT_CODE":
      return {
        ...state,
        billingCodes: action.payload.billingCodes,
        billingCodesLoading: false,
      };
    case "ERROR_BILLING_INPUT_CODE":
      return {
        ...state,
        billingCodesLoading: false,
        billingCodesError: action.error,
      };
    case "RESET_BILLING_INPUT_CODE":
      return {
        ...state,
        billingCodes: [],
        billingCodesError: null,
      };
    default:
      return state;
  }
};
